var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.errorMessages),function(error){return _c('div',[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(error)+"\n        ")])])}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.historyTemplate)}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"js":"babel-loader"}}!./node_modules/vue-loader/lib?{"loaders":{"js":"babel-loader"}}!./galaxy/scripts/components/DisplayStructured.vue?vue&type=template&id=8893f368
// module id = 719
// module chunks = 0